export default __webpack_public_path__ + "static/media/vendors-product-001.9da44868.png";